import { store } from '@betacrew/jars-flux';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { COMMON_EXPORTING_STATES, COMMON_LOADING_STATES, COMMON_DOWNLOAD_STATES, PAGE_STATE } from '../../constants/constants';
import ShortcutDataService from '../../../../services/ShortcutsDataService';
import { componentKey, setFormList, setPayerList, setSelectedForm, setSelectedPayer, setSelectedYear, setYearList, setLoadingState, setGridData, setTotalData, setExportFile } from './GenerateSummarySlice';
import { GENERATE_SUMMARY_LOADING_STATES } from './constants';

export const { getFilterData, getSummaryData, getPdfPreview, downloadAllPDFs, downloadPDFsForAllPayers, downloadPDFsForSelectedPayer } = {
    getFilterData: (payload) => {
        return {
            type: "GENERATESUMMARY/GET_FILTER_DATA",
            payload: payload
        }
    },
    getSummaryData: (payload) => {
        return {
            type: "GENERATESUMMARY/GET_SUMMARY_DATA",
            payload: payload
        }
    },
    getPdfPreview: (payload) => {
        return {
            type: "GENERATESUMMARY/GET_PDF_PREVIEW",
            payload: payload
        }
    },
    downloadAllPDFs: (payload) => {
        return {
            type: "GENERATESUMMARY/DOWNLOAD_ALL_PDFS",
            payload: payload
        }
    },
    downloadPDFsForAllPayers: (payload) => {
        return {
            type: "GENERATESUMMARY/DOWNLOAD_PDFS_FOR_ALL_PAYERS",
            payload: payload
        }
    },
    downloadPDFsForSelectedPayer: (payload) => {
        return {
            type: "GENERATESUMMARY/DOWNLOAD_PDFS_FOR_SELECTED_PAYER",
            payload: payload
        }
    },
}

function* getFilterDataAsync() {

    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Getting Filter Data..." }))
        const response = yield ShortcutDataService.getGenerateSummaryFilterData();

        if (response?.data.Status === 1) {
            const payersList = response.data.Data.PayerList.map(payer => ({ label: payer.label, value: payer.value }));
            yield put(setPayerList(payersList))
            yield put(setSelectedPayer({ label: "Select", value: "" }))

            const formList = response.data.Data.FormList.map(payer => ({ label: payer.label, value: payer.value }));
            yield put(setFormList(formList))
            yield put(setSelectedForm({ label: "Select", value: "" }))

            const yearList = response.data.Data.YearList.map(payer => ({ label: payer.label, value: payer.value }));
            yield put(setYearList(yearList))
            yield put(setSelectedYear({ label: "Select", value: "" }))

        } else {
            yield put(addNotifications({
                heading: "Failed to get filter data",
                message: response?.data?.Message
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Failed to get filter data",
            message: error?.response?.data?.Message
        }));

    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }

}

function* getSummaryDataAsync(action) {

    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting Grid Data..." }))
        const response = yield ShortcutDataService.getGeneratedSummaryData(action.payload);

        if (response?.data.Status === 1) {
            yield put(setGridData(response.data.Data.Data))
            yield put(setTotalData(response.data.Data.Total))

        } else {
            yield put(addNotifications({
                heading: "Failed to get grid data",
                message: response?.data?.Message
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Failed to get grid data",
            message: error?.response?.data?.Message
        }));

    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }

}

function* getPdfPreviewAsync(action) {

    try {
        yield put(setLoadingState({ state: `${COMMON_EXPORTING_STATES.EXPORT_LOADING}-${action.payload.referenceNo}`}))
        const response = yield ShortcutDataService.getPdfPreview(action.payload);

        if (response?.data.Status === 1) {
            yield put(setExportFile(response.data.Data))
        } else {
            yield put(addNotifications({
                heading: "Failed to get PDF",
                message: response?.data?.Message
            }));
        }

    } catch (error) {
        yield put(addNotifications({
            heading: "Failed to get PDF",
            message: error?.response?.data?.Message
        }));

    } finally {
        yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_READY }))
    }

}

function* downloadPDFsForSelectedPayerAsync(action) {

    try {
        yield put(setLoadingState({ state: GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_LOADING }))
        const response = yield ShortcutDataService.downloadPDFsForSelectedPayer(action.payload);

        if (response?.data.Status === 1) {
            yield put(setExportFile(response.data.Data))
        } else {
            yield put(addNotifications({
                heading: "Failed to get PDF",
                message: response?.data?.Message
            }));
        }

    } catch (error) {
        yield put(addNotifications({
            heading: "Failed to get PDF",
            message: error?.response?.data?.Message
        }));

    } finally {
        yield put(setLoadingState({ state: GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_READY }))
    }

}

function* downloadPDFsForAllPayersAsync(action) {

    try {
        yield put(setLoadingState({ state: GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_LOADING }))
        const response = yield ShortcutDataService.downloadPDFsForAllPayers(action.payload);

        if (response?.data.Status === 1) {
            yield put(setExportFile(response.data.Data))
        } else {
            yield put(addNotifications({
                heading: "Failed to get PDF",
                message: response?.data?.Message
            }));
        }

    } catch (error) {
        yield put(addNotifications({
            heading: "Failed to get PDF",
            message: error?.response?.data?.Message
        }));

    } finally {
        yield put(setLoadingState({ state: GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_READY }))
    }

}

function* downloadAllPDFsAsync(action) {

    try {
        yield put(setLoadingState({ state: GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_FOR_ALL_PDFS_LOADING }))
        const response = yield ShortcutDataService.downloadAllPDFs(action.payload);

        if (response?.data.Status === 1) {
            yield put(setExportFile(response.data.Data))
        } else {
            yield put(addNotifications({
                heading: "Failed to get PDF",
                message: response?.data?.Message
            }));
        }

    } catch (error) {
        yield put(addNotifications({
            heading: "Failed to get PDF",
            message: error?.response?.data?.Message
        }));

    } finally {
        yield put(setLoadingState({ state: GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_FOR_ALL_PDFS_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getFilterData().type, getFilterDataAsync),
        takeLatest(getSummaryData().type, getSummaryDataAsync),
        takeLatest(getPdfPreview().type, getPdfPreviewAsync),
        takeLatest(downloadAllPDFs().type, downloadAllPDFsAsync),
        takeLatest(downloadPDFsForAllPayers().type, downloadPDFsForAllPayersAsync),
        takeLatest(downloadPDFsForSelectedPayer().type, downloadPDFsForSelectedPayerAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);